/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBattery1 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 6v4h2v4h-2v4H2V6zm-2 2H4v8h14zM8 10v4H6v-4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBattery1 as Battery1 };
